import {langRegister} from "./langRegister";
import {salesChannelRegister} from "./salesChannelRegister";

class marketRegister {

    static default_market = "ae";

    static market = false;

    static available_markets = [
        {code: "se", name: langRegister.lang() === "sv" ? "Sverige" : "Sweden", names: {en: "Sweden", sv: "Sverige"}},
        {code: "ae", name: langRegister.lang() === "sv" ? "UAE" : "UAE", names: {en: "UAE", sv: "UAE"}}
    ];

    static markets = {
        se: {
            en: {
                code: "se",
                name: "Sweden",
                languages: [
                    {code: "en", name: "English"},
                    {code: "sv", name: "Svenska"}
                ],
                default_language: "sv",
                ad_language: "Swedish",
                currency: "SEK",
                vat: 25,
                channels: ["facebook", "instagram", "google", "bing"],
                country: {id: 1, name: "Sweden"},
                min_budget: 500,
                lower_min_budget: 100,
                low_plan: {
                    type: "low",
                    title: "Basic plan",
                    short_title: "Basic",
                    price: 100,
                    items: [
                        {title: "2 channels"},
                        {title: "1 location"},
                        {title: "Basic filtering"},
                        {title: "Free landing page"},
                        {title: "Basic support"}
                    ]
                },
                high_plan: {
                    type: "high",
                    title: "Basic plan",
                    short_title: "Basic",
                    price: 200,
                    items: [
                        {title: "All channels"},
                        {title: "Unlimited locations"},
                        {title: "Advanced filtering"},
                        {title: "Free landing page"},
                        {title: "Basic support"}
                    ]
                },
                master_plan: {
                    title: "Reseller plan",
                    short_title: "VIP",
                    price: 500,
                    items: [
                        {title: "All from advanced +"},
                        {title: "Tailor ads"},
                        {title: "Brand/point notifications"},
                        {title: "Create pay-later-campaigns"},
                        {title: "Get VIP insights"},
                        {title: "VIP support" }
                    ]
                },
                discount: 2,
                lockin: 12,
                title: "adBop | Annonsera online helt enkelt",
                trending_industries: [
                    {id: 10406, name: "House cleaning"},
                    {id: 12436, name: "Car wash"},
                    {id: 14025, name: "Plumbing"},
                    {id: 11551, name: "Laundry"},
                    {id: 11505, name: "Dry cleaning"}
                ]
            },
            sv: {
                code: "se",
                name: "Sverige",
                languages: [
                    {code: "en", name: "English"},
                    {code: "sv", name: "Svenska"}
                ],
                default_language: "sv",
                ad_language: "Svenska",
                currency: "SEK",
                vat: 25,
                channels: ["facebook", "instagram", "google", "bing"],
                country: {id: 1, name: "Sverige"},
                min_budget: 500,
                lower_min_budget: 100,
                low_plan: {
                    type: "low",
                    title: "Standardplan",
                    short_title: "Standard",
                    price: 100,
                    items: [
                        {title: "2 kanaler"},
                        {title: "1 område"},
                        {title: "Standard filtrering"},
                        {title: "Gratis landningssida"},
                        {title: "Standard support"}
                    ]
                },
                high_plan: {
                    type: "high",
                    title: "Standardplan",
                    short_title: "Standard",
                    price: 200,
                    items: [
                        {title: "Alla kanaler"},
                        {title: "Obegränsade områden"},
                        {title: "Avancerad filtrering"},
                        {title: "Gratis landningssida"},
                        {title: "Standard support"}
                    ]
                },
                master_plan: {
                    title: "Återförsäljare plan",
                    short_title: "VIP",
                    price: 500,
                    items: [
                        {title: "Allt från avancerad +"},
                        {title: "Skräddarsy annonser"},
                        {title: "Branda/peka notifikationer"},
                        {title: "Skapa betala-sen-kampanjer"},
                        {title: "Få VIP insikter"},
                        {title: "VIP support"}
                    ]
                },
                discount: 2,
                lockin: 12,
                title: "adBop | Annonsera online helt enkelt",
                trending_industries: [
                    {id: 10406, name: "Hemstädning"},
                    {id: 12436, name: "Biltvätt"},
                    {id: 14025, name: "Rörmokare"},
                    {id: 11551, name: "Tvätt"},
                    {id: 11505, name: "Kemtvätt"}
                ]
            }
        },
        ae: {
            en: {
                code: "ae",
                name: "UAE",
                languages: [
                    {code: "en", name: "English"},
                ],
                ad_language: "English",
                default_language: "en",
                currency: "AED",
                vat: 0,
                channels: ["facebook", "instagram", "google", "bing"],
                country: {id: 4940, name: "UAE"},
                min_budget: 200,
                lower_min_budget: 50,
                low_plan: {
                    type: "low",
                    title: "Basic plan",
                    short_title: "Basic",
                    price: 50,
                    items: [
                        {title: "2 channels"},
                        {title: "1 location"},
                        {title: "Basic filtering"},
                        {title: "Free landing page"},
                        {title: "Basic support"}
                    ]
                },
                high_plan: {
                    type: "high",
                    title: "Basic plan",
                    short_title: "Basic",
                    price: 100,
                    items: [
                        {title: "All channels"},
                        {title: "Unlimited locations"},
                        {title: "Advanced filtering"},
                        {title: "Free landing page"},
                        {title: "Basic support"}
                    ]
                },
                master_plan: {
                    title: "Reseller plan",
                    short_title: "VIP",
                    price: 250,
                    items: [
                        {title: "All from advanced +"},
                        {title: "Tailor ads"},
                        {title: "Brand/point notifications"},
                        {title: "Create pay-later-campaigns"},
                        {title: "Get VIP insights"},
                        {title: "VIP support"}
                    ]
                },
                discount: 2,
                lockin: 12,
                title: "adBop | Online ads made simple",
                trending_industries: [
                    {id: 16568, name: "House cleaning"},
                    {id: 17270, name: "Car wash"},
                    {id: 17384, name: "Plumbing"},
                    {id: 17077, name: "Laundry"},
                    {id: 17089, name: "Dry cleaning"}
                ]
            }
        }
    };

    static setMarket(market) {
        marketRegister.market = market;
        salesChannelRegister.set("market", market);
        langRegister.set(marketRegister.markets[market]["en"].default_language);
        try {
            sessionStorage.setItem("market", market);
        } catch (error) {}
    }

    static getMarket() {
        try{
            let market = salesChannelRegister.get("market");
            if (market) {
                return marketRegister.markets[market][langRegister.lang()];
            }
        }catch (e) {
            return marketRegister.markets[salesChannelRegister.get("market")][salesChannelRegister.get("default_language")];
        }
    }

    static getMarketValue(option) {
        try{
            let market = salesChannelRegister.get("market");
            if (market) {
                return marketRegister.markets[market][langRegister.lang()][option];
            }else{
                return null;
            }
        }catch (e) {
            //return marketRegister.markets[salesChannelRegister.get("market")][salesChannelRegister.get("default_language")][option];
            console.log(e);
        }
    }

    static getValue(market, lang, option){
        try{
            return marketRegister.markets[market][lang][option]
        }catch (e) {}
    }

    //SHORTENER
    static set(market) {
        marketRegister.setMarket(market);
    }

    static get() {
        return marketRegister.getMarket();
    }

    static allMarkets() {
        return marketRegister.available_markets;
    }

    static marketName() {
        return marketRegister.getMarketValue("name");
    }

    static code() {
        return salesChannelRegister.get("market");
    }

    static currency() {
        return marketRegister.getMarketValue("currency");
    }

    static vat() {
        return marketRegister.getMarketValue("vat");
    }

    static defaultLang() {
        return marketRegister.getMarketValue("default_language");
    }

    static country() {
        return marketRegister.getMarketValue("country");
    }

    static countryCode() {
        let country = marketRegister.getMarketValue("country");
        return country.id;
    }

    static languages() {
        return JSON.parse(salesChannelRegister.get("languages"))
    }

    static lowPlan() {
        return marketRegister.getMarketValue("low_plan");
    }

    static highPlan() {
        return marketRegister.getMarketValue("high_plan");
    }

    static masterPlan() {
        return marketRegister.getMarketValue("master_plan");
    }

    static minBudget() {
        return marketRegister.getMarketValue("min_budget");
    }

    static lowerMinBudget() {
        return marketRegister.getMarketValue("lower_min_budget");
    }

    static adLanguage() {
        return marketRegister.getMarketValue("ad_language");
    }

    static discount() {
        return marketRegister.getMarketValue("discount");
    }

    static lockin() {
        return marketRegister.getMarketValue("lockin");
    }

    static title() {
        return marketRegister.getMarketValue("title");
    }

    static trending() {
        return marketRegister.getMarketValue("trending_industries");
    }

}

export {marketRegister}


// WEBPACK FOOTER //
// ./src/services/marketRegister.js